export enum ReportTypes {
  EventLog = 'event log',

  Routes = 'routes',
  RoutesByVehicle = 'routes by vehicle',
  Stop = 'stops',
  StopsByVehicle = 'stops by vehicle',

  Fbt = 'fbt',
  Fbt12WeekDriverReport = 'fbt business driver',
  Fbt12WeekVehicleReport = 'fbt business vehicle',
  FbtDriver = 'fbt driver',
  FbtVehicle = 'fbt vehicle',

  AreaSummary = 'area summary',
  AreaVisited = 'area visited',
  AreaNotVisited = 'area not visited',

  FuelSummary = 'fuel summary',
  FuelRecords = 'fuel records',
  FuelRecordsByVehicle = 'fuel records by vehicle',

  DrivingBehaviourVehicle = 'driving behaviour vehicle',
  DrivingBehaviourDriver = 'driving behaviour driver',
  Speeding = 'speeding',

  MaintenanceSummary = 'maintenance summary',
  ServiceRecordsSummary = 'service records summary',
  ServiceRecordsDetailed = 'service records detailed',
  ServiceRecordsByVehicle = 'service records by vehicle',
  RepairsByVehicle = 'repairs by vehicle',
  MaintenanceTotal = 'maintenance total',
  MaintenanceTotalByVehicle = 'maintenance total by vehicle',

  VehicleSummary = 'vehicle summary',
  DailySummaryByVehicle = 'vehicle day summary',
  DriverSummary = 'driver summary',
  VehicleInspection = 'vehicle inspection',

  TemperatureByVehicle = 'temperature by vehicle',
  TemperatureBySensor = 'temperature by sensor',
  DigitalIO = 'digital i/o',
}

export const ReportRoutes = {
  /* Routes */
  [ReportTypes.Routes]: 'client/reports/routes_details/routes',
  [ReportTypes.RoutesByVehicle]: 'client/reports/routes_details/routes_by_vehicle',
  [ReportTypes.Stop]: 'client/reports/routes_details/stops',
  [ReportTypes.StopsByVehicle]: 'client/reports/routes_details/stops_by_vehicle',
  /* Business private */
  [ReportTypes.Fbt]: 'client/reports/business-private/fbt',
  [ReportTypes.Fbt12WeekDriverReport]: 'client/reports/business-private/fbt-12-week-driver-report',
  [ReportTypes.Fbt12WeekVehicleReport]: 'client/reports/business-private/fbt-12-week-vehicle-report',
  [ReportTypes.FbtDriver]: 'client/reports/business-private/fbt-driver-overview',
  [ReportTypes.FbtVehicle]: 'client/reports/business-private/fbt-vehicle-overview',
  /* Areas */
  [ReportTypes.AreaSummary]: 'client/reports/geofences_details/geofence_summary',
  [ReportTypes.AreaVisited]: 'client/reports/geofences_details/geofences_visited',
  [ReportTypes.AreaNotVisited]: 'client/reports/geofences_details/geofences_not_visited',
  /* Fuel */
  [ReportTypes.FuelSummary]: 'client/fuel/summary',
  [ReportTypes.FuelRecords]: 'client/fuel/records',
  [ReportTypes.FuelRecordsByVehicle]: 'client/fuel/records-by-vehicle',
  /* Driving behavior */
  [ReportTypes.DrivingBehaviourVehicle]: 'client/driving-behaviour/vehicles',
  [ReportTypes.DrivingBehaviourDriver]: 'client/driving-behaviour/drivers',
  [ReportTypes.Speeding]: 'client/reports/driving_behaviour/speeding',
  /* Maintenance */
  [ReportTypes.MaintenanceSummary]: 'client/reports/maintenance_details/maintenance_summary',
  [ReportTypes.ServiceRecordsSummary]: 'client/reports/maintenance_details/service_records_summary',
  [ReportTypes.ServiceRecordsDetailed]: 'client/reports/maintenance_details/service_records_detailed',
  [ReportTypes.ServiceRecordsByVehicle]: 'client/reports/maintenance_details/service_records_by_vehicle',
  [ReportTypes.RepairsByVehicle]: 'client/reports/maintenance_details/repairs_by_vehicle',
  [ReportTypes.MaintenanceTotal]: 'client/reports/maintenance_details/total_maintenance',
  [ReportTypes.MaintenanceTotalByVehicle]: 'client/reports/maintenance_details/total_maintenance_by_vehicle',
  /* Summary */
  [ReportTypes.VehicleSummary]: 'client/reports/summary_details/vehicle_summary',
  [ReportTypes.DriverSummary]: 'client/reports/summary_details/driver_summary',
  [ReportTypes.VehicleInspection]: 'client/reports/summary_details/vehicle_inspections',
  [ReportTypes.DailySummaryByVehicle]: 'client/reports/summary_details/daily-summary-by-vehicle',
  /* Sensor */
  [ReportTypes.TemperatureByVehicle]: 'client/reports/sensors-details/temperature-by-vehicle',
  [ReportTypes.TemperatureBySensor]: 'client/reports/sensors-details/temperature-by-sensor',
  [ReportTypes.DigitalIO]: 'client/reports/sensors-details/digital-io',
} as const

export const ReportTitles = {
  /* Routes */
  [ReportTypes.Routes]: 'REPORTS.TITLES.ROUTES',
  [ReportTypes.RoutesByVehicle]: 'REPORTS.TITLES.ROUTES_BY_VEHICLE',
  [ReportTypes.Stop]: 'REPORTS.TITLES.STOPS',
  [ReportTypes.StopsByVehicle]: 'REPORTS.TITLES.STOPS_BY_VEHICLE',
  /* Business private */
  [ReportTypes.Fbt]: 'REPORTS.TITLES.FBT',
  [ReportTypes.Fbt12WeekDriverReport]: 'REPORTS.TITLES.FBT_12_WEEK_DRIVER_REPORT',
  [ReportTypes.Fbt12WeekVehicleReport]: 'REPORTS.TITLES.FBT_12_WEEK_VEHICLE_REPORT',
  [ReportTypes.FbtDriver]: 'REPORTS.TITLES.FBT_OVERVIEW_DRIVER',
  [ReportTypes.FbtVehicle]: 'REPORTS.TITLES.FBT_OVERVIEW_VEHICLE',
  /* Areas */
  [ReportTypes.AreaSummary]: 'REPORTS.TITLES.AREA_SUMMARY',
  [ReportTypes.AreaVisited]: 'REPORTS.TITLES.AREA_VISITED',
  [ReportTypes.AreaNotVisited]: 'REPORTS.TITLES.AREA_NOT_VISITED',
  /* Fuel */
  [ReportTypes.FuelSummary]: 'REPORTS.TITLES.FUEL_SUMMARY',
  [ReportTypes.FuelRecords]: 'REPORTS.TITLES.FUEL_RECORDS',
  [ReportTypes.FuelRecordsByVehicle]: 'REPORTS.TITLES.FUEL_RECORDS_BY_VEHICLE',
  /* Driving behavior */
  [ReportTypes.DrivingBehaviourVehicle]: 'REPORTS.TITLES.DRIVING_BEHAVIOUR_VEHICLE',
  [ReportTypes.DrivingBehaviourDriver]: 'REPORTS.TITLES.DRIVING_BEHAVIOUR_DRIVER',
  [ReportTypes.Speeding]: 'REPORTS.TITLES.SPEEDING',
  /* Maintenance */
  [ReportTypes.MaintenanceSummary]: 'REPORTS.TITLES.MAINTENANCE_SUMMARY',
  [ReportTypes.ServiceRecordsSummary]: 'REPORTS.TITLES.SERVICE_RECORDS_SUMMARY',
  [ReportTypes.ServiceRecordsDetailed]: 'REPORTS.TITLES.SERVICE_RECORDS_DETAILED',
  [ReportTypes.ServiceRecordsByVehicle]: 'REPORTS.TITLES.SERVICE_RECORDS_BY_VEHICLE',
  [ReportTypes.RepairsByVehicle]: 'REPORTS.TITLES.REPAIRS_BY_VEHICLE',
  [ReportTypes.MaintenanceTotal]: 'REPORTS.TITLES.MAINTENANCE_TOTAL',
  [ReportTypes.MaintenanceTotalByVehicle]: 'REPORTS.TITLES.MAINTENANCE_TOTAL_BY_VEHICLE',
  /* Summary */
  [ReportTypes.VehicleSummary]: 'REPORTS.TITLES.VEHICLE_SUMMARY',
  [ReportTypes.DriverSummary]: 'REPORTS.TITLES.DRIVER_SUMMARY',
  [ReportTypes.VehicleInspection]: 'REPORTS.TITLES.VEHICLE_INSPECTIONS',
  [ReportTypes.DailySummaryByVehicle]: 'REPORTS.TITLES.DAILY_SUMMARY_BY_VEHICLE',
  /* Sensor */
  [ReportTypes.TemperatureByVehicle]: 'REPORTS.TITLES.TEMPERATURE_BY_VEHICLE',
  [ReportTypes.TemperatureBySensor]: 'REPORTS.TITLES.TEMPERATURE_BY_SENSOR',
  [ReportTypes.DigitalIO]: 'REPORTS.TITLES.DIGITAL_I/O',
}
